import { Component, OnInit } from '@angular/core';
import { MessageChannelService, messageLevel } from "@bndes/bndes-ux4/bndes-angular-utils";
import { ProgramasPermtidosPorCestasService } from '../programas-permitidos-por-cestas.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ProgramaBndesComIndicadorHabilitadoDTO, ProgramaRepasseBndes } from 'src/app/model/programas-permitidos.model';
import { ModalidadeGarantia } from 'src/app/model/modalidade_garantia.model';
import { ModalidadeGarantiaService } from '../../modalidade_garantia/modalidade-garantia.service';


export class ProgramaRepasseBndesView extends ProgramaRepasseBndes {
  public disabled: boolean;
}

@Component({
    selector: 'app-habilitacao-programa',
    templateUrl: './habilitacao-programa.component.html',
    styleUrls: ['./habilitacao-programa.component.scss'],
    standalone: false
})
export class HabilitacaoProgramaComponent implements OnInit {

  private idTranche: number;
  public dominioProgramas: ProgramaRepasseBndesView[];
  public programasPermitidos: ProgramaRepasseBndes[] = [];
  public programasAdicionados: ProgramaRepasseBndes[] = [];
  public modalidade: ModalidadeGarantia;

  constructor(protected route: ActivatedRoute,
    public programasPermitidosPorCestas: ProgramasPermtidosPorCestasService,
    private messageService: MessageChannelService,
    private router: Router,
    private modalidadeGarantiaService: ModalidadeGarantiaService) {
  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.idTranche = params['idTranche'];

      this.buscarTodos();
      this.programasPermitidos = [];
    });
  }

  public buscarTodos() {
    if (this.idTranche) {
      this.programasPermitidosPorCestas.buscarTodosComIndicadorHabilitado(this.idTranche).subscribe
        ((programas: ProgramaBndesComIndicadorHabilitadoDTO[]) => {
          this.dominioProgramas = programas.map((programa) => {
            const programaView: ProgramaRepasseBndesView = new ProgramaRepasseBndesView();
            programaView.id = programa.id
            programaView.descricaoPrograma = programa.descricaoPrograma
            programaView.disabled = programa.habilitado
            return programaView;
          });
        });
    }
    this.modalidadeGarantiaService.buscarModalidade().subscribe((modalidade:any) => {
      this.modalidade = modalidade;
    })
  }

  atribuirPrograma(programa: ProgramaRepasseBndesView, i) {
    const indexProgramaAAdicionar = this.dominioProgramas.findIndex(p => p.id === programa.id);
    if (indexProgramaAAdicionar > -1) {
      this.dominioProgramas[indexProgramaAAdicionar].disabled = true;
    }
    programa.indicadorEsco = this.modalidade?.utilizaIndicadorEscoParaProgramasAceitos ? false : null;
    programa.aceitaBeneficiarioCpfRepasse = false;
    programa.desconsiderarPrazoTotalMaximoContratual = false;
    programa.abonoEcg = false;
    this.programasAdicionados[i] = programa;
  }

  atribuirEscoPrograma(esco: boolean, i) {
    this.programasAdicionados[i].indicadorEsco = esco;
    console.log(this.programasAdicionados);
  }

  atribuirAceitaBeneficiarioPf(aceitaBeneficiarioCpfRepasse: boolean, i) {
    this.programasAdicionados[i].aceitaBeneficiarioCpfRepasse = aceitaBeneficiarioCpfRepasse;
    console.log(this.programasAdicionados);
  }

  atribuirDesconsiderarPrazo(desconsiderarPrazoTotalMaximoContratual: boolean, i) {
    this.programasAdicionados[i].desconsiderarPrazoTotalMaximoContratual = desconsiderarPrazoTotalMaximoContratual;
    console.log(this.programasAdicionados);
  }

  atribuirAbonoEcg(abonoEcg: boolean, i) {
    this.programasAdicionados[i].abonoEcg = abonoEcg;
    console.log(this.programasAdicionados);
  }

  removerPrograma(i) {
    const programaASerRemovido = this.programasPermitidos[i];
    const indexProgramaARemover = this.dominioProgramas.findIndex(programa => programa.id === programaASerRemovido.id);
    if (indexProgramaARemover > -1) {
      this.dominioProgramas[indexProgramaARemover].disabled = false;
    }
    this.programasPermitidos.splice(i, 1);
    this.programasAdicionados.splice(i, 1);
  }

  adicionarPrograma() {
    this.programasPermitidos.push(new ProgramaRepasseBndes());
    this.programasAdicionados.push(new ProgramaRepasseBndes());
  }

  podeSalvar() {
    return this.programasAdicionados.filter(programa => programa.id != null).length > 0;
  }

  salvar() {
    const programasIdsAAdicionar = this.programasAdicionados.map(p => p.id);
    const setProgramasIdsAAdicionar = new Set(programasIdsAAdicionar);
    if (programasIdsAAdicionar.length > setProgramasIdsAAdicionar.size) {
      this.messageService.addMessage({
        title: 'Sucesso',
        type: 'CRUD_OPERATION',
        level: messageLevel.ERROR,
        message: 'Há programa duplicado'
      });
      return;
    }

    this.programasPermitidosPorCestas.habilitar(this.idTranche, this.programasAdicionados.filter(programa => programa.id != null)).subscribe(() => {
      this.messageService.addMessage({
        title: 'Sucesso',
        type: 'CRUD_OPERATION',
        level: messageLevel.SUCCESS,
        message: 'Novo programa habilitado com sucesso'
      });
      this.router.navigate(["/programas-permitidos-por-cestas"])
    })
  }

  aceitaBeneficiarioPessoaFisicaRepasse(): boolean {
    return this.modalidade?.aceitaBeneficiarioPessoaFisicaRepasse;
  }

}
